import { z } from 'zod';

import { productTemplateCreateSchema, productTemplateSchema } from '../product-template';

//////////////////////////
// List
export const listReqSchema = z.object({
  params: z.object({}).nullish(),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type ListReq = z.infer<typeof listReqSchema>;

export const listResSchema = {
  200: z.object({
    data: z.object({
      productTemplates: z.array(productTemplateSchema),
    }),
  }),
};
export type ListRes = z.infer<(typeof listResSchema)[200]>;

//////////////////////////
// GetByBrandId
export const getPTemplatesByBrandIdReqSchema = z.object({
  params: z.object({
    id: productTemplateSchema.shape.brandId,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type GetPTemplatesByBrandIdReq = z.infer<typeof getPTemplatesByBrandIdReqSchema>;

export const getPTemplatesByBrandIdResSchema = {
  200: z.object({
    data: z.object({
      productTemplates: z.array(productTemplateSchema),
    }),
  }),
};
export type GetPTemplatesByBrandIdRes = z.infer<(typeof getPTemplatesByBrandIdResSchema)[200]>;

//////////////////////////
// Create
export const createProductTemplateReqSchema = z.object({
  params: z.object({}).nullish(),
  query: z.object({}).nullish(),
  body: productTemplateCreateSchema.strip(),
});
export type CreateProductTemplateReq = z.infer<typeof createProductTemplateReqSchema>;

export const createProductTemplateResSchema = {
  200: z.object({
    data: productTemplateSchema.strip(),
  }),
};
export type CreateProductTemplateRes = z.infer<(typeof createProductTemplateResSchema)[200]>;

//////////////////////////
// Get
export const getProductTemplateReqSchema = z.object({
  params: z.object({
    id: productTemplateSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type GetProductTemplateReq = z.infer<typeof getProductTemplateReqSchema>;

export const getProductTemplateResSchema = {
  200: z.object({
    data: productTemplateSchema.strip(),
  }),
};
export type GetProductTemplateRes = z.infer<(typeof getProductTemplateResSchema)[200]>;

//////////////////////////
// Get Used By Products
export const usedByProductsReqSchema = z.object({
  params: z.object({
    id: productTemplateSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type UsedByProductsReq = z.infer<typeof usedByProductsReqSchema>;

export const usedByProductsResSchema = {
  200: z.object({
    data: z.boolean(),
  }),
};
export type UsedByProductsRes = z.infer<(typeof usedByProductsResSchema)[200]>;

//////////////////////////
// Save
export const updateProductTemplateReqSchema = z.object({
  params: z.object({
    id: productTemplateSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: productTemplateCreateSchema.partial().strip(),
});
export type UpdateProductTemplateReq = z.infer<typeof updateProductTemplateReqSchema>;

export const updateProductTemplateResSchema = {
  200: z.object({
    ok: z.boolean(),
  }),
};
export type UpdateProductTemplateRes = z.infer<(typeof updateProductTemplateResSchema)[200]>;

//////////////////////////
// Delete
export const delProductTemplateReqSchema = z.object({
  params: z.object({
    id: productTemplateSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type DelProductTemplateReq = z.infer<typeof delProductTemplateReqSchema>;

export const delProductTemplateResSchema = {
  200: z.object({}),
};
export type DelProductTemplateRes = z.infer<(typeof delProductTemplateResSchema)[200]>;
